import UsersTypes from '../action-types/users';

const internals = {
    initial: () => ({
        paginatedUsers: {
            params: {
                page: 0,
                pageSize: 10,
                sortBy: 'createdAt',
                sortOrder: 'desc',
            },
            results: null,
            total: null,
        },
        allAttorneyUsers: {},
        allAttorneyUsersStatus: {
            error: false,
            completed: false,
        },
        paginatedUsersStatus: {
            error: false,
            completed: false,
        },
        addUserStatus: {
            error: false,
            completed: false,
        },
    }),
};

const AppReducer = (stateParam, action) => {
    const state = stateParam || internals.initial();

    const { type, payload } = action;

    switch (type) {
    case UsersTypes.GET_ALL_ATTORNEY_USERS_BEGIN:
        return {
            ...state,
            allAttorneyUsersStatus: {
                error: false,
                completed: false,
            },
        };
    case UsersTypes.GET_ALL_ATTORNEY_USERS_ERROR:
        return {
            ...state,
            allAttorneyUsersStatus: {
                error: true,
                completed: true,
            },
        };
    case UsersTypes.GET_ALL_ATTORNEY_USERS_SUCCESS:
        return {
            ...state,
            allAttorneyUsersStatus: {
                error: false,
                completed: true,
            },
            allAttorneyUsers: payload,
        };
    case UsersTypes.UPDATE_PAGINATED_USERS_PARAMS: {
        const newState = { ...state };
        newState.paginatedUsers.params = {
            ...state.paginatedUsers.params,
            ...payload,
        };
        return newState;
    }
    case UsersTypes.GET_PAGINATED_USERS_BEGIN:
        return {
            ...state,
            paginatedUsersStatus: {
                error: false,
                completed: false,
            },
        };
    case UsersTypes.GET_PAGINATED_USERS_ERROR:
        return {
            ...state,
            paginatedUsersStatus: {
                error: true,
                completed: true,
            },
        };
    case UsersTypes.GET_PAGINATED_USERS_SUCCESS:
        return {
            ...state,
            paginatedUsersStatus: {
                error: false,
                completed: true,
            },
            paginatedUsers: {
                ...state.paginatedUsers,
                results: payload.results,
                total: payload.total,
            },
        };
    case UsersTypes.ADD_USER_BEGIN:
        return {
            ...state,
            addUserStatus: {
                error: false,
                completed: false,
            },
        };
    case UsersTypes.ADD_USER_SUCCESS:
        return {
            ...state,
            addUserStatus: {
                error: false,
                completed: true,
            },
        };
    case UsersTypes.ADD_USER_ERROR:
        return {
            ...state,
            addUserStatus: {
                error: true,
                completed: true,
            },
        };

    default:
        // do nothing
    }
    return state;
};

export default AppReducer;
